export default __webpack_public_path__ + "static/media/spell_check.2142b513.svg";